import React, { useEffect, useState } from "react";
import { Col, Row, DatePicker, Form, FormInstance, Select, Input, Tag, Button, Spin } from 'antd';
import dayjs from 'dayjs';
import { IOutroCargo, ITipoFuncao } from "../Componentes/InterfaceOutroCargo";
import { IErroApi, IAreaConhecimento } from "../../../Interfaces/Interfaces";
import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../utils/messages";

import { maskCnpj } from "../../../utils/maskFunctions";
import { isValidCNPJ } from 'cnpj-cpf-validator';
import { IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import { hasText, onlyNumbers } from "../../../utils/utilsFunctions";
import { getPessoaJuridica, postPessoaJuridica } from "../../../services/apiCad";


interface IProps {
  form: FormInstance<any>;
  entidades: IEntidade[];
  tiposFuncoes: ITipoFuncao[];
  areasConhecimento: IAreaConhecimento[];
  dadosOutroCargo?: IOutroCargo;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 : Histórico;
}

const { Option } = Select;
const OutroCargoPerfil = ({ form, entidades, tiposFuncoes, areasConhecimento, manter, dadosOutroCargo }: IProps) => {

  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [cnpjReceitaFederal, setCnpjReceitaFederal] = useState<string>()


  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");
    }
  }, [erroApi])

  useEffect(() => {
    if (hasText(cnpjReceitaFederal)) {
      cadastroAutomaticoPessoaJuridica();
    }
    setCnpjReceitaFederal(undefined);

  }, [cnpjReceitaFederal])


  const handlerEntidade = async (value: any) => {
    form.setFieldsValue({
      sigla: value.children,
      matriculaEfpc: value.key,
    });
  };

  const handlerTipoFuncao = async (value: any) => {
    form.setFieldsValue({
      nmTipoFuncao: value.children,
      idTipoFuncao: value.key,
    });
  };

  const handlerAreaConhecimento = async (value: any) => {
    form.setFieldsValue({
      nmArea: value.children,
      idAreaConhecimento: value.key,
    });
  };

  const maskCnpjChange = async (isValue: any) => {
    form?.setFieldsValue({
      nuCnpj: maskCnpj(isValue),
    });
  };

  // Retorna CNPJ se cadastrado na base. Se não existir, faz o cadastro básico
  const getCnpJNaBase = async (value: string) => {
    setTipLoading("Buscando informações sobre o CNPJ na base PREVIC ...");
    setLoading(true);
    await getPessoaJuridica(value).then((response) => {
      setLoading(false);
      if (response?.data?.cnpj) {
        form.setFieldsValue({
          razaoSocial: response?.data?.razaoSocial,
          cnpj: response.data.cnpj,
        });
      }
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status === 404) { // NÃO LOCALIZOU O CNPJ NA BASE
          // BUSCA OS DADOS NA RECEITA FEDERAL E FAZ O CADASTRO AUTOMÁTICO DA PESSOA JURÍDICA COM OS DADOS REDUZIDOS
          setCnpjReceitaFederal(value);
        } else if (err.response.status < 500) {
          setErroApi(err.response.data);
          setLoading(false);
        } else {
          errorMessage(msgErro);
          setLoading(false);
        }
      });
  };

  const cadastroAutomaticoPessoaJuridica = async () => {
    setTipLoading("Cadastro automático de pessoa Jurídica ...");

    // console.log(cnpjReceitaFederal);
    if (!cnpjReceitaFederal) return;
    await postPessoaJuridica(cnpjReceitaFederal).then((response) => {
      setLoading(false);

      if (response?.data?.cnpj) {
        form.setFieldsValue({
          razaoSocial: response?.data?.razaoSocial,
          cnpj: response.data.cnpj,
        });
      }

      successMessage(
        `Pessoa Jurídica ${response?.data?.razaoSocial.toUpperCase()} cadastrada com Sucesso de Forma automática.`
      );

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };

  // Executado ao sair do campo nuCnpj
  const handleInputBlur = (nuCnpj: string) => {
    if (isValidCNPJ(nuCnpj)) {
      nuCnpj = onlyNumbers(nuCnpj); //Remove tudo o que não é dígito
      getCnpJNaBase(nuCnpj);
    }
  };

  return (
    <>
      <Spin spinning={loading} tip={tipLoading}>

        <Row>
          <Col xs={2} xl={2} style={{ display: manter === 1 || manter === 9 ? 'none' : 'inline' }}>
            <Form.Item label="Situação"
              labelCol={{ span: 24 }}
              colon={false}
            >
              <Tag color={dadosOutroCargo?.situacaoVigencia ? "geekblue" : "volcano"} key={dadosOutroCargo?.idOutroCargo}>
                {dadosOutroCargo?.situacaoVigencia && dadosOutroCargo.situacaoVigencia ? "ATIVO" : "INATIVO"}
              </Tag>
            </Form.Item>
          </Col>

          <Col xs={24} xl={10}>
            <Form.Item label="Entidade"
              name="sigla"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "A entidade é obrigatória",
                },
              ]}
            >
              <Select
                disabled={manter !== 1 ? true : entidades.length === 1}
                showSearch
                filterOption
                optionFilterProp='children'
                placeholder='Selecione a entidade'
                onChange={(_, index) => {
                  handlerEntidade(index);
                }}
              >
                {entidades?.map((e: IEntidade) => (
                  <Option key={e.matricula} value={e.matricula}>
                    {e.sigla}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} xl={12}>
            <Form.Item label="Tipo Cargo/Função"
              name="nmTipoFuncao"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "O tipo de cargo/função é obrigatório",
                },
              ]}
            >
              <Select
                disabled={manter === 2 || manter === 9 ? true : false}
                showSearch
                filterOption
                optionFilterProp='children'
                placeholder='Selecione o tipo de cargo/função'
                onChange={(_, index) => {
                  handlerTipoFuncao(index);
                }}
              >
                {tiposFuncoes?.map((e: ITipoFuncao) => (
                  <Option key={e.idTipoFuncao} value={e.idTipoFuncao}>
                    {e.nmTipoFuncao}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>

          <Col xs={24} xl={9}>
            <Form.Item label="Área de Atuação"
              name="nmArea"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "A área de atuação é obrigatória",
                },
              ]}
            >
              <Select
                disabled={manter === 2 || manter === 9 ? true : false}
                showSearch
                filterOption
                optionFilterProp='children'
                placeholder='Selecione a área'
                onChange={(_, index) => {
                  handlerAreaConhecimento(index);
                }}
              >
                {areasConhecimento?.map((e: IAreaConhecimento) => (
                  <Option key={e.idAreaConhecimento} value={e.idAreaConhecimento}>
                    {e.nmArea}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={8} xl={6}>
            <Form.Item label="Data Inicial de Atuação"
              name="dtInicioAtuacao"
              colon={false}
              style={{ flexDirection: "column", alignItems: "flex-start" }}
              rules={[
                {
                  required: true,
                  message: "Campo obrigatório",
                },
              ]}
            >
              <DatePicker
                disabled={manter === 2 || manter === 9 ? true : false}
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
                placeholder="Selecionar Data"
              />
            </Form.Item>
          </Col>

          <Col xs={8} xl={6}>
            <Form.Item label="Data Final de Atuação"
              name="dtFimAtuacao"
              colon={false}
              style={{ flexDirection: "column", alignItems: "flex-start" }}
              rules={[
                {
                  validator: async (_, endDatetime) => {
                    let startDatetime = form.getFieldValue("dtInicioAtuacao");
                    if (endDatetime && startDatetime) {
                      endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                      startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                      if (endDatetime <= startDatetime) {
                        return Promise.reject(
                          "Data de final de atuação deve ser maior do que à data inicial"
                        );
                      }
                    }
                  },
                },
              ]}
            >
              <DatePicker
                disabled={manter === 2 || manter === 9 ? true : false}
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
                placeholder="Selecionar Data"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} xl={6}>
            <Form.Item
              label='CNPJ da Empresa Externa'
              name='nuCnpj'
              rules={[
                {
                  message: 'Insira um CNPJ válido.',
                  validator: (_, value) => {
                    if (value && value.length > 0) {
                      if (value.length === 18) {
                        if (isValidCNPJ(value)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject('CNPJ inválido');
                        }
                      }
                    } else {
                      return Promise.resolve();
                    }
                  }
                }
              ]}
            >
              <Input
                disabled={manter === 2 || manter === 9 ? true : false}
                value={form.getFieldValue("nuCnpj")}
                onChange={(e) => maskCnpjChange(e.target.value)}
                maxLength={18}
                onBlur={(e) => handleInputBlur(e.target.value)} />
            </Form.Item>
          </Col>

          <Col xs={24} xl={3}>
            <Form.Item
              label=" "
              labelCol={{ span: 16 }}
            >
              <Button
                disabled={manter === 2 || manter === 9 ? true : false}
                type="primary"
              >
                Pesquisar
              </Button>
            </Form.Item>
          </Col>

          <Col xs={24} xl={15}>
            <Form.Item
              label='Nome da Empresa Externa'
              name='razaoSocial'>
              <Input
                maxLength={100}
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
      </Spin>

    </>
  )
};

export default OutroCargoPerfil;